import api, {API_POST_ENGAGEMENT_EVENT, getProticoClient} from ".";

export interface Voucher {
  token: string;
  invited_by: string;
  is_valid: boolean;
}

export interface IRedeemVoucherData {
  token: string;
  invited_by: string;
  user_id: string;
}

export async function postEngagementEvent(event_type: string, domain: string) {
  try {
    await getProticoClient().api.post(API_POST_ENGAGEMENT_EVENT, {
      event_type,
      domain
    });
  } catch (err) {}
}

